import {getRandomInt} from "./number";
import {generateFromString} from "generate-avatar";

const RandomAvatarHtmlClass = 'avatar__random';

export function getRandomAvatarStyles() {
    return `
    object-fit: none; 
    object-position: ${getRandomInt(10, 50)}% ${getRandomInt(10, 50)}%; 
    transform: rotate(${getRandomInt(0, 365)}deg) scale(${getRandomInt(110, 200)}%); 
    transform-origin: center; 
    filter: contrast(${getRandomInt(3, 6)/10}) blur(${getRandomInt(5, 8)}px); 
    `;
}

export function getRandomAvatarElement(personIdentifier, personInitials) {
    personIdentifier = personIdentifier || 'unknown'
    personInitials = personInitials || ''

    let element = document.createElement('div');
    element.classList.add(RandomAvatarHtmlClass);
    element.innerHTML = `<div class="avatar__random__initials">${ personInitials }</div>`;

    const svgData = generateFromString(personIdentifier);

    let imgElement = document.createElement('img');
    imgElement.classList.add('avatar__random__img');
    imgElement.setAttribute('style', getRandomAvatarStyles());
    imgElement.src = `data:image/svg+xml;utf8,${svgData}`;

    element.append(imgElement);

    return element;
}
